import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const writingItems = [
  {
    id: 1,
    image: require("../images/latest-writing/news-4.png"),
    name: "PV60",
    date: "23 April 2025",
    description: `
<p>PREMIER 200 compressor system packages for FLUE GAS DESULFURIZATION application. Designed for handling 24,000 CFM of flue gas at 0.6 kg/cm² discharge pressure. Made with S.S 316L material grade to withstand the extreme corrosive operating environment of Sulphuric Acid as a result of Sulphur vapours reacting with water.</p>
`
  },
  {
    id: 2,
    image: require("../images/latest-writing/news-7.jpeg"),
    name: "PV60",
    date: "09 January 2025",
    description: `
<p>PREMIER offers its unique performance evaluation services for Liquid Ring Vacuum Pumps with minimum pump shutdown time, giving in time failure predictions and minimizing plant shutdown costs due to pump failure.</p>
`
  },
  {
    id: 3,
    image: require("../images/latest-writing/news-3.jpg"),
    name: "PV60",
    date: "16 November 2024",
    description: `
<p>PREMIER make P501 M pump equivalent to NASH 904 M arrives in a paper mill in the U.S.A</p>
<p>Contact PREMIER for your emergency requirements to replace your existing O.E.M Vacuum Pumps and spares.</p>
`
  },
  {
    id: 4,
    image: require("../images/latest-writing/news-5.png"),
    name: "PV60",
    date: "14 August 2024",
    description: `
<p>PREMIER make centrifugal pumps for pulp and process fluid handling applications.</p>
<p>With several models covering a wide range of flow and head requirements, PREMIER can supply pumps in various material grades to handle corrosive fluid applications.</p>
`
  },
  {
    id: 5,
    image: require("../images/latest-writing/news-8.jpeg"),
    name: "PV60",
    date: "31 May 2024",
    description: `
<p>PREMIER, the ASH HANDLING Vacuum system experts, can provide 100% interchangeable pumps and spares of any O.E.M with material grades that are ideal for abrasive ash handling applications.</p>
`
  },
  {
    id: 6,
    image: require("../images/latest-writing/news-2.jpg"),
    name: "P300",
    date: "07 February 2024",
    description: `
<p>PREMIER make Vacuum Pump port plates in S.S. 304 to withstand the demanding environment of Ash Handling in Thermal Power Plants.</p>
<p>PREMIER guarantees 100% interchangeability with your existing O.E.M pumps and spares.</p>
`
  },
  {
    id: 8,
    image: require("../images/latest-writing/news-6.png"),
    name: "PV60",
    date: "12 October 2024",
    description: `
<p>PREMIER's in house three ton capacity Dynamic Balancing machine. </p>
<p>All rotor shaft assemblies are dynamically balanced as per ISO 1940 G6.3</p>

`
  },
  {
    id: 9,
    image: require("../images/latest-writing/news-9.jpg"),
    name: "PV60",
    date: "29 July 2023",
    description: `
<p>PREMIER is the largest exporter of Liquid Ring Vaccuum Pumps and Spares with installations in more than forty countries.</p>
`
  },
  {
    id: 10,
    image: require("../images/latest-writing/news-10.jpg"),
    name: "PV60",
    date: "11 March 2023",
    description: `
<p>PREMIER team conducting a product training seminar in B.H.E.L</p>
`
  },
];
// Writing Items

const News = () => {
  return (
    <div className="container my-5">
      <h1 className="mb-4">News</h1>
      <div className="row">
        {writingItems.map((item) => {
          const plainText = item.description.replace(/<\/?[^>]+(>|$)/g, "");
          const shortText = plainText.length > 80 ? plainText.substring(0, 80) + "..." : plainText;
          return (
            <div key={item.id} className="col-lg-4 col-6  mb-4">
              <div className="card h-100">
                <img src={item.image} className="card-img-top" alt={item.name} />
                <div className="card-body">
                  <p className="card-text text-muted">{item.date}</p>
                  <p className="card-text">{shortText}</p>
                  <Link
                    to={`/writing-details/${item.id}`}
                    className="stretched-link"
                    state={{
                      name: item.name,
                      date: item.date,
                      description: item.description,
                      image: item.image
                    }}
                  >
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default News;
